<template>
  <footer class="border-t border-line bg-base-800">
    <div class="container-app py-12">
      <div class="grid grid-cols-2 md:grid-cols-4 gap-8">
        <!-- Brand -->
        <div class="col-span-2 md:col-span-1">
          <a href="/" class="flex items-center gap-2.5 mb-4">
            <img src="@/assets/logo-2.png" alt="Akademi Siber" class="h-9 w-auto" />
            <span class="text-base font-extrabold tracking-tight text-white">
              Akademi<span class="text-brand">Siber</span>
            </span>
          </a>
          <p class="text-sm text-ink-muted leading-relaxed">
            We born hackers. Hands-on cybersecurity training with real labs, AI mentoring, and a competitive community.
          </p>
        </div>

        <!-- Learn -->
        <div>
          <h4 class="text-xs font-bold uppercase tracking-wider text-ink-faint mb-4">Learn</h4>
          <ul class="space-y-2.5">
            <li><a href="/modules" class="text-sm text-ink-muted hover:text-white">Course Modules</a></li>
            <li><a href="/machine-labs" class="text-sm text-ink-muted hover:text-white">Machine Labs</a></li>
            <li><a href="/ai-labs" class="text-sm text-ink-muted hover:text-white">AI Mentored Lab</a></li>
            <li><a href="/leaderboard" class="text-sm text-ink-muted hover:text-white">Leaderboard</a></li>
          </ul>
        </div>

        <!-- Account -->
        <div>
          <h4 class="text-xs font-bold uppercase tracking-wider text-ink-faint mb-4">Account</h4>
          <ul class="space-y-2.5">
            <li><a href="/login" class="text-sm text-ink-muted hover:text-white">Login</a></li>
            <li><a href="/register" class="text-sm text-ink-muted hover:text-white">Create Account</a></li>
            <li><a href="/subscribe" class="text-sm text-ink-muted hover:text-white">Pricing</a></li>
          </ul>
        </div>

        <!-- Partners -->
        <div>
          <h4 class="text-xs font-bold uppercase tracking-wider text-ink-faint mb-4">Partners</h4>
          <div class="space-y-4">
            <div>
              <p class="text-[11px] text-ink-faint mb-1.5">Brought to you by</p>
              <img src="@/assets/partners/siberlab-logo.png" alt="SiberLab ID" class="h-6 object-contain" />
            </div>
            <div>
              <p class="text-[11px] text-ink-faint mb-1.5">In partnership with</p>
              <img src="@/assets/partners/redac7d.png" alt="REDAC7D" class="h-6 object-contain" />
            </div>
          </div>
        </div>
      </div>

      <div class="mt-10 pt-6 border-t border-line flex flex-col sm:flex-row items-center justify-between gap-4">
        <p class="text-xs text-ink-faint">© {{ year }} SiberLab ID. All Rights Reserved.</p>
        <div class="flex items-center gap-4 text-ink-faint">
          <a href="#" class="hover:text-brand transition-colors"><i class="fab fa-github"></i></a>
          <a href="#" class="hover:text-brand transition-colors"><i class="fab fa-linkedin"></i></a>
          <a href="#" class="hover:text-brand transition-colors"><i class="fab fa-instagram"></i></a>
          <a href="#" class="hover:text-brand transition-colors"><i class="fab fa-discord"></i></a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
/* eslint-disable vue/multi-word-component-names */
export default {
  name: "SiteFooter",
  data() {
    return { year: new Date().getFullYear() };
  },
};
</script>
